import React from 'react';
import { useDiscoveryContext } from '../context/DiscoveryContext';
import MessageList from './MessageList';
import ChatInput from './ChatInput';

export default function ChatPanel({ onReset }) {
  const { state, dispatch } = useDiscoveryContext();
  const hasMessages = state.messages.length > 0;

  return (
    <div className="chat-panel" data-testid="chat-panel">
      {hasMessages && (
        <div className="chat-header">
          <span className="chat-header-title">Chat</span>
          <button
            type="button"
            className="chat-reset-btn"
            data-testid="chat-reset-btn"
            aria-label="Start a new chat"
            onClick={onReset}
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <polyline points="23 4 23 10 17 10" />
              <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
            </svg>
            <span>New Chat</span>
          </button>
        </div>
      )}
      {state.error && (
        <div className="chat-error" role="alert" data-testid="chat-error">
          <span>{state.error}</span>
          <button
            onClick={() => dispatch({ type: 'SET_ERROR', payload: null })}
            aria-label="Dismiss error"
            data-testid="chat-error-dismiss"
          >
            ×
          </button>
        </div>
      )}
      <MessageList />
      <ChatInput />
    </div>
  );
}
